import { render, staticRenderFns } from "./SignalR_test.vue?vue&type=template&id=ab4556cc&"
import script from "./SignalR_test.vue?vue&type=script&lang=js&"
export * from "./SignalR_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports